import { space } from '@op/opds.tokens';
import { ReactElement } from 'react';
import { useMessage, Message } from '@messageformat/react';
import CourseHeader from '../CourseHeader';
import { ReactComponent as Image034 } from '../../images/OP_symbolikuvitus_128_034.svg';
import TaskOne from './TaskOne';
import TaskTwo from './TaskTwo';
import InvestorProfiles from './InvestorProfiles';
import HighlightedList from '../HighlightedList';
import CourseContent from '../CourseContent';
import parseMsgContent from '../../util/parseMsgContent';
import CourseComplete from '../CourseComplete';
import TextComponent from '../TextComponent';

const Course5 = (): ReactElement => {
  const riskContent = useMessage('course5.courseContent.risklevel');
  const activityContent = useMessage('course5.courseContent.acitivitylevel');

  const parsedRisks = parseMsgContent(riskContent);
  const parsedActivity = parseMsgContent(activityContent);
  return (
    <div style={{ marginBottom: space.default }}>
      <CourseHeader
        courseTitleId="course5.title"
        courseHeaderText="learn_more"
        courseNumber={5}
        Image={Image034}
      />
      <TextComponent messageId="course5.introduction" twoColumns />
      <HighlightedList
        title="course5.highlighted_message.title"
        messageId="course5.highlighted_message.body"
      />
      <div className="investoracademy-number" aria-hidden="true">
        1
      </div>
      <h2
        className="opds-styles-v1-text-hero-small"
        style={{
          textAlign: 'center',
          paddingBottom: space.default,
          paddingTop: space.small,
        }}
      >
        <span className="sr-only">{`1. `}</span>
        <Message id="course5.courseContent.title1" />
      </h2>
      <CourseContent content={parsedRisks} />
      <div
        className="investoracademy-number"
        aria-hidden="true"
        style={{ marginTop: space.xxl }}
      >
        2
      </div>
      <h2
        className="opds-styles-v1-text-hero-small"
        style={{
          textAlign: 'center',
          paddingBottom: space.default,
          paddingTop: space.small,
        }}
      >
        <span className="sr-only">{`2. `}</span>
        <Message id="course5.courseContent.title2" />
      </h2>
      <CourseContent content={parsedActivity} />
      <TaskOne />
      <TaskTwo />
      <div
        className="investoracademy-number"
        style={{ marginTop: space.xxl }}
        aria-hidden="true"
      >
        3
      </div>
      <h2
        className="opds-styles-v1-text-hero-small"
        style={{
          textAlign: 'center',
          paddingBottom: space.default,
          paddingTop: space.small,
        }}
      >
        <span className="sr-only">{`3. `}</span>
        <Message id="course5.courseContent.title3" />
      </h2>
      <InvestorProfiles />
      <CourseComplete messageId="course5.recap" />
    </div>
  );
};

export default Course5;
